import React from "react"
import { fromJSX, IOWidget, Updater, any } from "widgets-for-react"
import { FormControls } from "../../../../../../../Shared/Frontend/forms"
import { capitalize } from "../../../../../../../Shared/Frontend/utils/capitalize"
import { DonationFormState, DonationFormStepState, DonationFormType, donationFormUpdaters, getAmountsForForm, PredefinedAmounts, getStep2Validation, Step2PersonalData, getManualAmount } from "../donationFormBlock.state"
import { t } from "i18next"
import { dataLayerServices } from "../../../../../seo/datalayer"
import Recaptcha from "react-grecaptcha"

const Step2Layout = (props: {
  blockIndex: number,
  predefinedAmounts?: PredefinedAmounts,
  manualAmount?: number,
  manualAmountValidation?: string,
  formType: DonationFormType,
  formTypeOptions: DonationFormType[]
  monthlyText?: string,
  yearlyText?: string,
  submitLabel: string,
  customTitle?: string,
  amountOnClick: (index: number) => (_: boolean) => void,
  updateAmount: (_: string) => void,
  nextStepOnClick: (buttonText: string) => void,
  recurringOnClick: (_: string) => (_: boolean) => void,
  emailUpdater: (_: string) => void,
  onBlur: (field?: keyof Step2PersonalData) => () => void,
  state: DonationFormStepState<'2-AmountForm'>,
}) => {
  const {
    blockIndex,
    predefinedAmounts,
    manualAmount,
    manualAmountValidation,
    formType,
    formTypeOptions,
    monthlyText,
    customTitle,
    yearlyText,
    submitLabel,
    amountOnClick,
    updateAmount,
    nextStepOnClick,
    recurringOnClick,
    emailUpdater,
    onBlur,
    state,
  } = props
  const emailValidation = getStep2Validation(state, "email")
  return <>
    {
      formTypeOptions.length > 1 && <><FormControls.FormRadioInGroup
        key={`donation-interval-b${blockIndex}`}
        name={`donation-interval-b${blockIndex}`}
        legend='Hoe vaak wil je geven?'
        disabled={false}
        required={false}
        style='button'
        items={formTypeOptions.map((item, index) => {
          const checked = item == formType;
          return {
            controlId: `donation-interval-b${blockIndex}-${index}`,
            label: t(`DonationBlock:DonationForm.Label_${item}`),
            checked: checked,
            onChange: recurringOnClick(item)
          }
        })}
      />
        {formType == 'monthly-sign-on' && monthlyText && <div className="donation__description text--s"><p>{monthlyText}</p></div>}
        {formType == 'yearly-sign-on' && yearlyText && <div className="donation__description text--s"><p>{yearlyText}</p></div>}
      </>
    }


    <FormControls.FormRadioInGroup
      key={`donation-amount-b${blockIndex}`}
      name={`donation-amount-b${blockIndex}`}
      legend={formType == 'yearly-sign-on' ? t("DonationBlock:DonationForm.Label_Yearly_AmountSelector") : formType == 'monthly-sign-on' ? t("DonationBlock:DonationForm.Label_Monthly_AmountSelector") : t("DonationBlock:DonationForm.Label_AmountSelector")}
      disabled={false}
      required={false}
      style='button'
      items={predefinedAmounts?.amounts.map((item, index) => ({
        controlId: `donation-amount-b${blockIndex}-${index}`,
        label: capitalize(item.button),
        checked: index == predefinedAmounts.selectedIndex ? true : false,
        onChange: amountOnClick(index)
      })).concat({
        controlId: `donation-amount-b${blockIndex}-${predefinedAmounts?.amounts.length}`,
        label: t("DonationBlock:DonationForm.Label_Custom_Amount"),
        checked: predefinedAmounts.selectedIndex == undefined,
        onChange: amountOnClick(undefined!)
      }) || []}
    />

    {predefinedAmounts?.selectedIndex == undefined &&
      <div className='donation__amount' ref={ref => {
        const input = ref?.getElementsByTagName("input")[0]
        if (!input) return ref
        input.removeEventListener("keydown", blockCharacter)
        input.addEventListener("keydown", blockCharacter)
      }}>
        <FormControls.FormItemInGroup
          min="0"
          step="1"
          key={`donation-amount-b${blockIndex}-i`}
          controlId={`donation-amount-b${blockIndex}-i`}
          type='number'
          inputMode='numeric'
          label=""
          disabled={false}
          required={false}
          value={manualAmount == undefined ? '' : manualAmount.toString()}
          onChange={updateAmount}
          errorMessage={manualAmountValidation}
        />
      </div>
    }

    {state.selectedFormType == 'express' && <FormControls.FormItemInGroup
      key={`donation-email-b${blockIndex}`}
      controlId={`donation-email-b${blockIndex}`}
      type='email'
      inputMode='email'
      label={t("DonationBlock:DonationForm.Label_email")}
      disabled={false}
      required={false}
      value={state.input.email}
      placeholder=''
      onChange={emailUpdater}
      onBlur={onBlur('email')}
      errorMessage={emailValidation.kind == 'failed' ? emailValidation.message : undefined}
    />}

    {predefinedAmounts?.amounts.map((amount, index) => (index == predefinedAmounts.selectedIndex) && <div className="donation__description text--s"><p>{amount.explainerText ? amount.explainerText : ''}</p></div>)}

    <div className='donation__action'>
      <button className={`button button--primary`} onClick={_ => nextStepOnClick(submitLabel)}>
        <span className="button__label">{submitLabel}</span>
      </button>
    </div>
  </>
}

export const step2AmountFormWidget: IOWidget<DonationFormStepState<'2-AmountForm'>, Updater<DonationFormState>> = s =>
  any([
    s.validator.widget().map((v) => donationFormUpdaters.step2validationUpdater((_) => v)),
    fromJSX(
      updateState => {
        const manualAmount = getManualAmount(s)
        const nextStepFunc = (r: string) => {
          const amount = manualAmount
            ? manualAmount.toString()
            : getAmountsForForm(s).amounts[s.predefinedAmounts["single-sign-on"].selectedIndex
              ? s.predefinedAmounts["single-sign-on"].selectedIndex
              : 0
            ].amount.toString()

          dataLayerServices.donationFormDataLayer("1", "Next_step")
          s.selectedFormType == 'express' && dataLayerServices.scheduleTransactionCheckoutDataLayer(
            amount,
            window.location.href,
            'once',
            [{
              name: 'donation',
              price: amount,
              variant: 'fo-1',
              category: 'giftgever',
              quantity: '1'
            }])
            s.selectedFormType == 'express' &&  dataLayerServices.scheduleSuccessDataLayer(window.location.href)
          updateState(donationFormUpdaters.transitionFromStep2(r))
        }
        return <>
          <Step2Layout
            blockIndex={s.blockIndex}
            predefinedAmounts={getAmountsForForm(s)}
            manualAmount={manualAmount}
            manualAmountValidation={s.manualAmountError}
            formType={s.selectedFormType}
            formTypeOptions={s.formTypeOptions}
            monthlyText={s.monthlyText}
            yearlyText={s.yearlyText}
            submitLabel={s.submitButton}
            customTitle={s.customTitle}
            state={s}
            emailUpdater={(str: string) => {
              dataLayerServices.newDataLayerEventInteraction()
              updateState(donationFormUpdaters.inputStep2Updater('email', str))
            }}
            onBlur={(field?: keyof Step2PersonalData) => () => {
              dataLayerServices.newDataLayerEventInteraction();
              updateState(donationFormUpdaters.step2ValidateFields(field))
            }}
            amountOnClick={(index: number) => () => {
              let amounts = getAmountsForForm(s)
              const amount = index ? amounts.amounts[index].amount.toString() : "custom"
              dataLayerServices.newDataLayerEventAmount(amount)
              dataLayerServices.donationCheckoutDataLayer(
                2,
                'express',
                'once',
                [{
                  name: 'donation',
                  price: amount,
                  variant: 'fo-0',
                  category: 'giftgever',
                  quantity: '1'
                }])
              updateState(donationFormUpdaters.togglePredefinedAmount(index))
            }}
            updateAmount={(newVal: string) => {
              dataLayerServices.newDataLayerEventAmount(newVal)
              dataLayerServices.donationCheckoutDataLayer(
                2,
                'express',
                'once',
                [{
                  name: 'donation',
                  price: newVal,
                  variant: 'fo-0',
                  category: 'giftgever',
                  quantity: '1'
                }])
              updateState(donationFormUpdaters.updateManualAmount(newVal))
            }}
            nextStepOnClick={(buttonText: string) => {
              dataLayerServices.newDataLayerEventButton("1", buttonText)
              if (s.selectedFormType == "express") {
                updateState(donationFormUpdaters.step2ValidateFields())
                window.grecaptcha.reset()
                window.grecaptcha.execute()
              } else {
                nextStepFunc('')
              }
            }}
            recurringOnClick={(type) => () => {
              dataLayerServices.newDataLayerEventAction(type)
              updateState(donationFormUpdaters.toggleRecurring(type))
            }}
          />
          <div id="recaptcha-content">
            <Recaptcha
              locale="NL_nl"
              sitekey={(document.getElementById('recaptchaToken') as any).value}
              callback={
                (r: string) => {
                  nextStepFunc(r)
                }
              }
              expiredCallback={() => window.grecaptcha.reset()}
              invisible
            />
          </div>
        </>
      })
  ])

const blockCharacter = (e: KeyboardEvent) => {
  if (e.key === "," || e.key === ".") {
    e.stopImmediatePropagation()
    e.stopPropagation()
    e.preventDefault()
  }
}
